/**
 * Eenvoudige SVG-staafgrafiek in de stijl van de referentie.
 * Bewust geen chart-bibliotheek: de referentie tekent zijn grafieken zelf,
 * en zo blijft de bundel klein en de kleuren exact gelijk.
 */
export function HourChart({
  data,
  xKey,
  yKey,
  height = 120,
  color = 'var(--acc2)',
  format,
}: {
  data: Record<string, string | number>[]
  xKey: string
  yKey: string
  height?: number
  color?: string
  format?: (v: number) => string
}) {
  if (!data.length) return <div className="chartempty" style={{ height }}>No data in this window</div>
  const max = Math.max(1, ...data.map((d) => Number(d[yKey]) || 0))
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, height }}>
        {data.map((d, i) => {
          const v = Number(d[yKey]) || 0
          const h = Math.max(1, Math.round((v / max) * 100))
          return (
            <div
              key={i}
              title={`${d[xKey]}: ${format ? format(v) : v}`}
              style={{
                flex: 1, height: `${h}%`, background: color,
                opacity: v ? 0.85 : 0.18, borderRadius: '3px 3px 0 0',
              }}
            />
          )
        })}
      </div>
      <div className="row mut2" style={{ fontSize: 12, justifyContent: 'space-between', marginTop: 4 }}>
        <span>{String(data[0][xKey])}</span>
        <span>max {format ? format(max) : max}</span>
        <span>{String(data[data.length - 1][xKey])}</span>
      </div>
    </div>
  )
}
